import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const ConfirmationModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchConfirmationModal = (): void => {
  load().catch(() => null);
};
